import { v4 as uuidv4 } from 'uuid';
import { Environment } from '../../../../environment';
import axios, { AxiosError } from 'axios';
import { Api } from '../../axiosApi';
import { comOffline } from '../../../../offline/servico';
import { buscarOperacoes, buscarOperacaoPorId } from '../../../../offline/cadastros';

export interface IListagemOperacoes {
  idoperacoes: string;
  descricao: string;
  tipooperacao: string;
  pagamento: number;
  tpag: number;
  tipo: number;
  faturamento: boolean;
  status: boolean;
}
export interface IDetalheOperacoes {
  descricao: string;
  tipo: number;
  estoque: boolean;
  faturamento: boolean;
  status: boolean;
  tpag: number;
}
type TComTotalCount = {
    data: IListagemOperacoes[];
    totalCount: number;
}
interface ErrorResponse {
  errors: {
    default: string;
  };
}
const getAll = async (page = 1, filter = '', limit = Environment.LIMITE_DE_LINHASSMALL): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = `/estoqueoperacoes?page=${page}&limit=${limit}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHASSMALL),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAlllistOnline = async (filter = '', id = '', tipo: number): Promise<TComTotalCount | Error> => {
  try {
    // Só busca por id (resolver o rótulo da seleção já salva) quando o usuário ainda não
    // digitou nada — checar só `id === ''` fazia digitar pra buscar outra operação ser
    // ignorado enquanto uma já estivesse selecionada (ou um id salvo inválido), travando quem
    // tentasse corrigir. Ver mesmo fix em MunicipiosService.getAlllist.
    const urlRelativa: string = (filter === '' && id !== '') ? `/estoqueoperacoeslist/${id}` : `/estoqueoperacoeslist?limit=${Environment.LIMITE_DE_LINHASSMALL}&filter=${filter}&tipo=${tipo}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHASSMALL),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getByIdOnline = async (id: string): Promise<IDetalheOperacoes | Error> => {
  try {
    const { data } = await Api.get(`/estoqueoperacoes/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const create = async (dados: IDetalheOperacoes): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const { data } = await Api.post<IDetalheOperacoes>('/estoqueoperacoes',  {idoperacoes: guuid, ...dados});
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const updateById = async (id: string, dados: IDetalheOperacoes): Promise<void | Error> => {
  try {
    await Api.put(`/estoqueoperacoes/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/estoqueoperacoes/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
// Resolve (ou cadastra, se ainda não existir) o idoperacoes de cada nome
// pedido — usado pelo SeletorFormasPagamento pra dar às formas de pagamento
// "extras" (Cheque, Boleto, Transferência, Outros) um id real do cadastro de
// operações, já que idoperacao é referenciado (uuid) em outras tabelas.
const resolverPorDescricao = async (descricoes: string[]): Promise<Record<string, string> | Error> => {
  try {
    const { data } = await Api.post<Record<string, string>>('/estoqueoperacoes/resolver', { descricoes });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

// ---------- Offline (ver shared/offline) ----------
const getAlllist = (filter = '', id = '', tipo: number): Promise<TComTotalCount | Error> =>
  comOffline(
    () => getAlllistOnline(filter, id, tipo),
    () => buscarOperacoes(filter, filter === '' ? id : '', tipo, Environment.LIMITE_DE_LINHASSMALL),
  );

const getById = (id: string): Promise<IDetalheOperacoes | Error> =>
  comOffline(
    () => getByIdOnline(id),
    async () => (await buscarOperacaoPorId(id).catch(() => undefined)) ?? new Error('Operação não encontrada na cópia offline — sincronize com internet.'),
  );

export const EstoqueOperacoesService = {
  getAll,
  getAlllist,
  create,
  getById,
  updateById,
  deleteById,
  resolverPorDescricao,
};